export enum InvoiceOriginType {
  integrator = 'integrator',
  user = 'user',
}